var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "judgmentForm",
      attrs: {
        inline: false,
        model: _vm.vicePresidentAJudgment,
        "label-width": "150px"
      }
    },
    [
      !_vm.isReappraisal
        ? _c(
            "div",
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "Εισήγηση Ειδ. Εισηγητή:", size: "small" }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.specialProponentProposal)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Ημ/νια εισήγησης:", size: "small" } },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.reviewProposalDate) + "\n     "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Σχόλιο Προέδρου:", size: "small" } },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.presidentComment) + "\n    "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && (_vm.fromPrechecker || _vm.fromPresident)
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Αρμόδιος Εισηγητής:", size: "small" } },
                [_c("span", [_vm._v(_vm._s(_vm.proponentInCharge))])]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Εσωτερικό Σχόλιο:" } },
        [
          _c("el-input", {
            staticClass: "commentText",
            attrs: {
              type: "textarea",
              placeholder: "Εισάγετε εσωτερικό σχόλιο",
              autosize: { minRows: 4, maxRows: 10 }
            },
            on: { change: _vm.modifyInternalComment },
            model: {
              value: _vm.vicePresidentAJudgment.internalComment,
              callback: function($$v) {
                _vm.$set(_vm.vicePresidentAJudgment, "internalComment", $$v)
              },
              expression: "vicePresidentAJudgment.internalComment"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("proposals"),
      _vm._v(" "),
      _c("internalComments"),
      _vm._v(" "),
      _vm.showDSDecisionText
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Απόφαση Δ.Σ.:", size: "small" } },
                [
                  _c("el-input", {
                    staticClass: "commentText",
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 10 },
                      size: "100",
                      placeholder:
                        "Εισάγετε το αποτέλεσμα της ψηφοφορίας του Δ.Σ."
                    },
                    on: { change: _vm.modifyViceComment },
                    model: {
                      value: _vm.vicePresidentAJudgment.comment,
                      callback: function($$v) {
                        _vm.$set(_vm.vicePresidentAJudgment, "comment", $$v)
                      },
                      expression: "vicePresidentAJudgment.comment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isReappraisal &&
              (!_vm.praktikoDSFound ||
                _vm.viceUploaded ||
                this.workingApplication.attachedDocuments.slice(-1)[0]
                  .uploadedBy === this.currentUser.id)
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Πρακτικό Δ.Σ." } },
                    [
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: this.uploading,
                              expression: "this.uploading"
                            }
                          ],
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            accept: ".pdf",
                            action: "",
                            "file-list": this.viceAttachments.filter(function(
                              doc
                            ) {
                              return doc.type === _vm.calcFileType
                            }),
                            "http-request": _vm.addAttachment,
                            "on-remove": _vm.handleRemove,
                            "before-remove": _vm.handleBeforeRemove,
                            "on-preview": _vm.viewPdf,
                            "auto-upload": true,
                            "show-file-list": true,
                            limit: 1
                          }
                        },
                        [
                          _vm.attachments.length === 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    type: "primary",
                                    size: "small"
                                  },
                                  slot: "trigger"
                                },
                                [_vm._v("Επιλογή Αρχείου\n        ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [
                              _vm._v(
                                "** Ανεβάστε το πρακτικό του Δ.Σ. (προαιρετικά)"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.praktikoDSFound
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          type: "info",
                          title:
                            "Yπάρχει ανεβασμένο το πρακτικό ΔΣ (στην καρτέλα Επισυναπτόμενα)",
                          "show-icon": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && _vm.fromBoard
        ? _c(
            "div",
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { hit: "", shadow: "" } },
                [
                  _vm.boardJudgement
                    ? _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _vm._v(
                            "Αποφάσεις Μελών Εκτελεστικής Επιτροπής\n      "
                          ),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.boardJudgement.judgment }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "Όνομα", width: "120" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.firstname))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "Επώνυμο", width: "120" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.surname))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              !_vm.isReappraisal
                                ? _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        label: "Αποδοχή πρότασης",
                                        align: "center"
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Εισηγητή",
                                          width: "90",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                scope.row.agreeWithProponent ===
                                                true
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "agree-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-check"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.agreeWithProponent ===
                                                false
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "disagree-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-close"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _vm.fromConsultant
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "Ακαδημαικού Συμβούλου",
                                              width: "110",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    scope.row.agreeWithAC ===
                                                    true
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "agree-btn"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-check"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.agreeWithAC ===
                                                    false
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "disagree-btn"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ])
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isReappraisal
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Πλήρης αποδοχή",
                                      align: "center",
                                      width: "150"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row
                                              .fullyAgreeWithReappraisal ===
                                            true
                                              ? _c(
                                                  "span",
                                                  { staticClass: "agree-btn" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-check"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row
                                              .fullyAgreeWithReappraisal ===
                                            false
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "disagree-btn"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-close"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "Εισήγηση" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              trigger: "click",
                                              placement: "top-start",
                                              title: "Εισήγηση: "
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { color: "blue" },
                                                attrs: { slot: "reference" },
                                                slot: "reference"
                                              },
                                              [_vm._v("Πατήστε για άνοιγμα")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  scope.row.proposal
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Υποβολή",
                                  width: "85",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.finalize === true
                                          ? _c(
                                              "span",
                                              { staticClass: "done-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.finalize === false
                                          ? _c(
                                              "span",
                                              { staticClass: "pending-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-edit"
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !this.reappraisalBoardExists
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ανάθεση " } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Παρακαλώ Επιλέξτε" },
                          on: { change: _vm.toggleAssignTo },
                          model: {
                            value: _vm.vicePresidentAJudgment.assignedTo.role,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.vicePresidentAJudgment.assignedTo,
                                "role",
                                $$v
                              )
                            },
                            expression: "vicePresidentAJudgment.assignedTo.role"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "σε Ειδ. Επιτρ. Επανεξέτασης",
                              value: "SpecialReappraisalBoardMember"
                            }
                          }),
                          _vm._v(" "),
                          !this.vicePresidentAJudgment.boardUnanimous
                            ? _c("el-option", {
                                attrs: {
                                  label: "σε Πρόεδρο",
                                  value: "President"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.reappraisalBoardExists &&
              _vm.vicePresidentAJudgment.assignedTo.role ===
                "SpecialReappraisalBoardMember"
                ? _c(
                    "div",
                    [
                      _c("el-form-item", { attrs: { size: "small" } }, [
                        _vm._v("Ορισμός Ειδικής Επιτροπής Επανεξέτασης\n      ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Πρακτικό ορισμού", size: "small" } },
                        [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.reappraisalBoardRec,
                              callback: function($$v) {
                                _vm.reappraisalBoardRec = $$v
                              },
                              expression: "reappraisalBoardRec"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.newReappraisalBoard }
                            },
                            [_vm._v("Νέα Επιτροπή")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.reappraisalBoardExists &&
              _vm.vicePresidentAJudgment.assignedTo.role
                ? _c(
                    "div",
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card",
                          attrs: { hit: "", shadow: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "5px",
                                "margin-bottom": "5px"
                              },
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _vm._v(
                                "Μέλη Ειδικής Επιτροπής Επανεξέτασης\n      "
                              ),
                              _vm._v(" "),
                              _c("el-alert", {
                                attrs: {
                                  type: "info",
                                  title:
                                    "Βρέθηκε η υπ.αριθμ. " +
                                    this.reappraisalBoard.name +
                                    " ειδική επιτροπή",
                                  "show-icon": ""
                                }
                              }),
                              _vm._v(" "),
                              _c("el-transfer", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loadingInternalUsers,
                                    expression: "loadingInternalUsers"
                                  }
                                ],
                                staticStyle: {
                                  "margin-top": "20px",
                                  "text-align": "left",
                                  display: "inline-block"
                                },
                                attrs: {
                                  filterable: "",
                                  titles: [
                                    "Διαθέσιμοι Χρήστες",
                                    "Μέλη επιτροπής"
                                  ],
                                  "button-texts": ["Αφαίρεση", "Προσθήκη"],
                                  format: {
                                    noChecked: "${total}",
                                    hasChecked: "${checked}/${total}"
                                  },
                                  data: _vm.users
                                },
                                on: {
                                  change: _vm.addUserToReappBoard,
                                  "left-check-change": _vm.usersToAssignChanged,
                                  "right-check-change":
                                    _vm.usersToReleaseChanged
                                },
                                model: {
                                  value: _vm.reappraisalBoard.members,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reappraisalBoard,
                                      "members",
                                      $$v
                                    )
                                  },
                                  expression: "reappraisalBoard.members"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && _vm.fromReappraisalBoard
        ? _c(
            "div",
            [
              _c(
                "el-card",
                [
                  _vm._v("Απόφαση Επιτροπής Επανεξέτασης\n      "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.reappraisalBoardJudgment }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Όνομα" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.firstname))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Επώνυμο" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.surname))])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Ημ/νία" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.date.substring(0, 10))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.isReappraisal
                        ? _c("el-table-column", {
                            attrs: { label: "Πλήρης αποδοχή", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.fullyAgreeWithReappraisal === true
                                      ? _c(
                                          "span",
                                          { staticClass: "agree-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-check"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.fullyAgreeWithReappraisal ===
                                    false
                                      ? _c(
                                          "span",
                                          { staticClass: "disagree-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-close"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.fullyAgreeWithReappraisal === null
                                      ? _c(
                                          "span",
                                          { staticClass: "pending-btn" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-minus"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.tempSave()
                }
              }
            },
            [_vm._v("Αποθήκευση")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: _vm.cannotSave
              },
              on: {
                click: function($event) {
                  _vm.finalSave()
                }
              }
            },
            [_vm._v("Ολοκλήρωση")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d3f394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d3f394","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/VicePresidentAJudgment.vue
// module id = null
// module chunks = 